import React, { useEffect } from "react";
import { TitleSetup } from "../Datas/Functions/titleSetup";
import { useForm } from "react-hook-form";
import SectionHeader from "../Components/SectionHeader/SectionHeader";
import { useState } from "react";
import { profileData, profileData2 } from "../Datas/ProfileDatas/selfProfile";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../Contexts/AuthContext";
import loginPNG from "./../Imgs/login.png";
import { useSiteData } from "../Contexts/SiteContext";
const Login = (meta) => {
  const {  login } = useAuthContext();
  const [openPass, setOpenPass] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const { isLoggedin } = useSiteData();
  let navigate = useNavigate();
  let location = useLocation();
  console.log("login page");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
  };
  TitleSetup({...meta});

  return (
    <div className="flex items-center justify-center min-h-screen dark:dark-bg-back">
      <div className="md:w-10/12 lg:w-7/12 contai ner md:mx-auto p-4 flex flex-wrap flex-row justify-between ring-1 ring-orange-500 dark:dark-bg-front bg-front rounded-lg shadow-lg m-4">
        <div
          className={`w-1/2  px-6 my-auto mx-auto transition-all duration-700 z-10 ${
            isLogin ? "" : "md:translate-x-full"
          } `}
        >
          <img
            className="w-auto mx-auto aspect-square"
            src={loginPNG}
            alt={"Login PNg"}
          />
        </div>
        <div
          className={`w-full md:w-1/2  px-6 my-2 mx-auto transition-all duration-700 order-1  ${
            isLogin ? "" : "md:-translate-x-full"
          }`}
        >
          <SectionHeader heading={isLogin ? "LOGIN" : "REGISTER"} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              className={`mb-4 transform duration-1000 origin-top transition-all overflow-hidden ${
                isLogin ? "scale-y-0 max-h-0" : "scale-y-100 max-h-auto"
              }`}
            >
              <label htmlFor="email" className="block mb-2">
                Name
              </label>
              <div className="flex items-center">
                <span className="inline-block w-6 h-6 mr-2">
                  <i className="fa fa-user" aria-hidden="true"></i>
                </span>
                <input
                  type="text"
                  className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none  focus:border-orange-300  ${
                    errors.name ? "border-red-500" : "border-green-500"
                  }`}
                  placeholder="Enter your Name..."
                  {...register("name", {
                    required: "Please Enter your Name",
                  })}
                />
              </div>
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.name.message}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block mb-2">
                Email
              </label>
              <div className="flex items-center">
                <span className="inline-block w-6 h-6 mr-2">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
                <input
                  type="email"
                  className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none  focus:border-orange-300  ${
                    errors.email ? "border-red-500" : "border-green-500"
                  }`}
                  placeholder="Enter your Email..."
                  {...register("email", {
                    required: "Please Enter your Email",
                  })}
                />
              </div>
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="block mb-2">
                Password
              </label>
              <div className="flex items-center relative">
                <span className="inline-block w-6 h-6 mr-2">
                  <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
                <div className="w-full relative">
                  <input
                    type={openPass ? "text" : "password"}
                    className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none focus:border-orange-300 ${
                      errors.password ? "border-red-500" : "border-green-500"
                    }`}
                    placeholder="Enter your password"
                    {...register("password", {
                      required: "Please Enter Your Password...",
                      minLength: {
                        value: 6,
                        message: "Password must be minimum 6 digit long",
                      },
                    })}
                  />
                  <span
                    onClick={() => setOpenPass((prev) => !prev)}
                    className="absolute right-1 top-2 text-gray-50 cursor-pointer w-5 h-5 rounded-full flex items-center justify-center click-effect dark-bg-front"
                  >
                    {openPass ? (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    )}
                  </span>
                </div>
              </div>

              {errors.password && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>
            <button
              type="submit"
              className="site-btn font-bold py-2 px-4 rounded mx-auto block"
            >
              Sign In <i className="fa fa-sign-in" aria-hidden="true"></i>
            </button>
          </form>
          <div className="flex flex-wrap items-center justify-evenly flex-row  my-3">
            <p
              className="text-orange-500 cursor-pointer "
              onClick={() => setIsLogin((prev) => !prev)}
            >
              {isLogin ? "Create Account" : "Go to Login"}
            </p>
            <p className="text-orange-500 cursor-pointer">Forgot Password </p>
          </div>
          <p className="text-center">Temporary buttons</p>
          <div className="flex flex-wrap items-center flex-row justify-evenly my-3">
            <button
              className="site-btn p-2"
              onClick={() => {
                login(profileData2);
              }}
            >
              Login as USER
            </button>
            <button
              className="site-btn p-2"
              onClick={() => {
                login(profileData);
              }}
            >
              Login as Admin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
